// Translation for en
export const as = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'চেট সেৱা এইমুহূৰ্তত উপলব্ধ নহয়। অনুগ্ৰহ কৰি পিছত আকৌ চেষ্টা কৰক।'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'পাঠ্যক্রম',
                buttonTitle: 'পাঠ্যক্রমৰ বিষয়বস্তু দেখুৱাওক',
                modalTitle: '{app} পাঠ্যক্রম',
                sections: {
                    topic: 'পাঠ্যক্রমৰ বিষয়',
                    explanation: 'শিশু-বন্ধুত্বপূৰ্ণ ব্যাখ্যা',
                    studentProfile: 'ছাত্ৰৰ প্ৰফাইল'
                },
                topic: {
                    empty: 'এই মাইক্ৰো-এপৰ সৈতে কোনো পাঠ্যক্রমৰ বিষয় সংযুক্ত নাই।',
                    missingDetail: 'এই মাইক্ৰো-এপৰ বাবে বিস্তৃত পাঠ্যক্রম তথ্য এতিয়াও উপলব্ধ নহয়।',
                    learningGoals: 'শিক্ষণ লক্ষ্য',
                    prerequisites: 'পূৰ্বশৰ্ত',
                    unitLabel: 'একক',
                    durationLabel: 'সময়সীমা',
                    difficultyLabel: 'কঠিনতা',
                    hours: 'ঘণ্টা',
                    minutes: 'মিনিট'
                },
                explanation: {
                    empty: 'কোনো শিশু-বন্ধুত্বপূৰ্ণ ব্যাখ্যা উপলব্ধ নাই।',
                    loadingPrepare: 'AI-এ ব্যাখ্যা প্ৰস্তুত কৰি আছে',
                    loadingExplain: 'AI-এ শিশু-বন্ধুত্বপূৰ্ণ ভাষাত বিষয়টো বুজাই আছে',
                    requestFailed: 'শিশু-বন্ধুত্বপূৰ্ণ ব্যাখ্যা সৃষ্টি কৰিব পৰা নগ\'ল।'
                },
                studentProfile: {
                    country: 'দেশ',
                    region: 'ৰাজ্য / অঞ্চল',
                    schoolType: 'বিদ্যালয়ৰ প্ৰকাৰ',
                    grade: 'শ্ৰেণী',
                    noContext: 'কোনো ছাত্ৰৰ প্ৰসংগ উপলব্ধ নাই।',
                    childProfileNotFound: 'বৰ্তমান লগইনৰ বাবে কোনো ছাত্ৰৰ প্ৰফাইল পোৱা নগ\'ল।',
                    loginProfileIncomplete: 'লগইন প্ৰফাইলত এতিয়াও সম্পূৰ্ণ ছাত্ৰ প্ৰসংগ নাই।',
                    educationContextNotFound: 'এটা ছাত্ৰ প্ৰফাইল পোৱা গৈছে, কিন্তু কোনো পাঠ্যক্রম নিৰ্ধাৰণ কৰা নাই।',
                    noToken: 'কোনো লগইন কৰা ছাত্ৰ পোৱা নগ\'ল।'
                },
                errors: {
                    signInRequired: 'পাঠ্যক্রম চাবলৈ অনুগ্ৰহ কৰি চাইন ইন কৰক।',
                    appIdMissing: 'এপ আইডি নাই।',
                    loadFailed: 'পাঠ্যক্রম তথ্য ল\'ড কৰিব পৰা নগ\'ল।'
                }
            }
    };
